import { render } from "./sick-index.vue?vue&type=template&id=a7275204"
import script from "./sick-index.vue?vue&type=script&lang=js"
export * from "./sick-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__